var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrupo1002(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.404,
    height: 81.404,
    viewBox: "0 0 81.404 81.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_46",
    x: 0,
    y: 0,
    width: 81.404,
    height: 81.404,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.835,
    dy: 2.835,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.417,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5b5b5b",
    floodOpacity: 0.349
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1002",
    "data-name": "Grupo 1002",
    transform: "translate(-816.48 -548.198)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 816.48, 548.2)",
    filter: "url(#Elipse_46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_46-2",
    "data-name": "Elipse 46",
    cx: 36.45,
    cy: 36.45,
    r: 36.45,
    transform: "translate(1.42 1.42)",
    fill: "#e30613"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(-2828.729 -6267.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_782",
    "data-name": "Trazado 782",
    d: "M3681.244,6855.211l-.876-13.111q-.246-3.831-.246-5.5a4.989,4.989,0,0,1,1.19-3.545,4.089,4.089,0,0,1,3.134-1.273,3.155,3.155,0,0,1,3.148,1.629,11.017,11.017,0,0,1,.794,4.694,35.73,35.73,0,0,1-.192,3.667l-1.177,13.5a10.586,10.586,0,0,1-.821,3.694,2.15,2.15,0,0,1-2.08,1.287,2.072,2.072,0,0,1-2.053-1.245A12.4,12.4,0,0,1,3681.244,6855.211Zm3.038,18.009a4.3,4.3,0,0,1-2.914-1.081,3.783,3.783,0,0,1-1.246-3.023,4.063,4.063,0,0,1,4.106-4.079,4.058,4.058,0,0,1,2.942,1.19,3.894,3.894,0,0,1,1.218,2.889,3.822,3.822,0,0,1-1.232,3.01A4.189,4.189,0,0,1,3684.282,6873.22Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo1002);
export default __webpack_public_path__ + "static/media/Grupo 1002.ddd7046ece560e6d608c975af3e84a25.svg";
export { ForwardRef as ReactComponent };